import { useMemo } from 'react';
import { useRouter } from 'next/router';
import useAnalyticsEvents from '../useAnalyticsEvents';

export default function useErrorTracking() {
  const { sendEventToPosthog } = useAnalyticsEvents();
  const router = useRouter();

  const errorTrackingFunctions = useMemo(() => {
    return {
      checkoutErrorShown: ({ source, code, message }) => {
        sendEventToPosthog('checkout_error_shown', {
          step_name: router.pathname,
          error_source: source,
          error_code: code,
          error_message: message,
        });
      },
    };
  }, [router.pathname, sendEventToPosthog]);

  return errorTrackingFunctions;
}
